const sameIdentity = (left, right) => left != null && right != null && left === right;

export const isRoiStatsRequestOwnerCurrent = ({ requestOwner, currentOwner }) => Boolean(
  requestOwner
  && currentOwner
  && sameIdentity(requestOwner.seriesLoadGeneration, currentOwner.seriesLoadGeneration)
  && sameIdentity(requestOwner.studyInstanceUID, currentOwner.studyInstanceUID)
  && sameIdentity(requestOwner.seriesInstanceUID, currentOwner.seriesInstanceUID)
  && Number.isFinite(requestOwner.slice)
  && requestOwner.roiId != null
  && requestOwner.roiSubjectToken
);

export const applyRoiStatsIfOwned = ({ rois, requestOwner, currentOwner, stats }) => {
  const source = Array.isArray(rois) ? rois : [];
  if (!isRoiStatsRequestOwnerCurrent({ requestOwner, currentOwner })) return source;
  let matched = false;
  const next = source.map(roi => {
    if (
      roi?.id !== requestOwner.roiId
      || roi?.statsSubjectToken !== requestOwner.roiSubjectToken
      || roi?.slice !== requestOwner.slice
    ) return roi;
    matched = true;
    return { ...roi, stats };
  });
  return matched ? next : source;
};
